import { DiscordInviteLinkValidationDto } from 'shared/interfaces/SmartAssistant';
import { axiosBaseInstance } from 'shared/utils/axios-instances';
const discordBaseEndpoint = '/discord';

export const DiscordService = {
  validateInviteLink: async (link: string): Promise<DiscordInviteLinkValidationDto> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${discordBaseEndpoint}/validate-invite-link`,
      data: {
        link
      }
    });

    return response.data;
  },
  getAuthLink: async (link: string): Promise<string> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${discordBaseEndpoint}/auth-link`,
      data: {
        link
      }
    });

    return response.data.authLink;
  }
};
